export class EsitoConsegnaInfratel {
    
  esitoPositvo!:boolean;
  noteBocciatura!:string;
  dataInvio!: Date;
  dataResponso!: Date;
  dataPecOde!: Date;

}
  